import './Audiences.scss'
import React from 'react'

function Audiences({ part = 'all' }) {
    const showIntro = part !== 'list'
    const showList = part !== 'intro'

    return (
        <section
            className="audiences"
            aria-labelledby={showIntro ? 'audiences-title' : undefined}
            aria-label={showIntro ? undefined : 'Votre activité, votre site'}
        >
            <div className="audiences__container">
                {showIntro && (
                <header className="audiences__header">
                    <h2
                        id="audiences-title"
                        className="audiences__title"
                    >
                        Votre activité, votre site
                    </h2>

                    <p className="audiences__intro">
                        J’accompagne des indépendants, des équipes et des
                        structures variées dans leurs choix techniques — que
                        vous ayez besoin d’un site, d’une architecture
                        repensée ou d’outils mieux connectés.
                    </p>

                    <p className="audiences__intro">
                        Chaque mission est pensée en fonction de votre
                        activité, de votre organisation et du niveau
                        d’autonomie que vous souhaitez garder.
                    </p>
                </header>
                )}

                {part === 'list' && (
                    <p className="sectionEyebrow">Votre activité, votre site</p>
                )}

                {showList && (
                <ul
                    className="audiences__list"
                    aria-label="Types d'activités accompagnées"
                >
                    <li>Commerces indépendants</li>
                    <li>Marques et e-commerce</li>
                    <li>Équipes & agences</li>
                    <li>Professions libérales</li>
                    <li>Architectes et studios</li>
                    <li>Artistes, photographes et scénographes</li>
                    <li>Associations</li>
                    <li>Structures culturelles</li>
                    <li>Collectivités</li>
                </ul>
                )}
            </div>
        </section>
    )
}

export default Audiences